/** Takes a string of text and returns the acronym version - up to 2 letters */
export const acronym = (text: string) => {
  const letters = text
    .split(/\s/)
    .reduce((response: string, word: string) => (response += word.slice(0, 1)), '');
  return letters.slice(0, 2);
};
